import React, { Component } from "react";
import { Link } from "preact-router/match";
import styles from "./MobileMenu.scss";
import SignUpButton from "./global/SignUpButton";
import CMSComponent from "./CMSComponent";

import { css } from "emotion";

import config from "../config";
import ColorServices from "../services/ColorServices";
import { firstOfType } from "../utils/CssUtils";

const menuIcon = require("../assets/hamburger/ic_menu.svg");
const closeIcon = require("../assets/hamburger/ic_close.svg");
const HumanitixLogo = require("../assets/humanitixLogos/mobile.svg");

const hollowArrow = require("../assets/ic_expand_more.svg");

const DropDown = ({ title, children, open, toggle }) => {
  const dropDownWrapper = css({
    button: {
      width: "100%",
      background: "transparent",
      fontSize: 16,
      border: "none",
      padding: 0,
      display: "flex",
      alignItems: "center",
      paddingRight: 16,
      justifyContent: "space-between",
      color: "#323232",
      img: {
        marginLeft: 4,
        transform: `rotateZ(${open ? -180 : 0}deg)`
      }
    },
    div: {
      padding: "14px 14px 0px 14px"
    }
  });

  return (
    <div className={dropDownWrapper}>
      <button onClick={toggle}>
        {title} <img src={hollowArrow} aria-hidden={true} />
      </button>
      {open ? <div>{children}</div> : null}
    </div>
  );
};

const openButton = css({
  border: "none",
  backgroundColor: "transparent"
});

const closeButton = css({
  border: "none",
  backgroundColor: "transparent"
});

const header = css({
  display: "flex",
  justifyContent: "space-between",
  padding: "22px 14px",
  borderBottom: "1px solid #dedede",
  marginBottom: 24
});

const linksList = css({
  listStyle: "none",
  paddingLeft: 14,
  li: {
    fontSize: 16,
    marginBottom: 16
  }
});
const menuWrapper = css({
  position: "absolute",
  width: "100vw",
  minHeight: 300,
  background: "white",
  transition: "0.25s ease-out",
  boxShadow: "0 2px 3px 0 rgba(32, 7, 64, 0.13)",
  borderBottomLeftRadius: 4,
  borderBottomRightRadius: 4,
  left: 0,
  top: 0,
  zIndex: 1000
});

const footer = css({
  backgroundColor: ColorServices.getColor("greyBackground"),
  padding: "16px 0",
  display: "flex",
  justifyContent: "center",
  button: {
    [firstOfType()]: {
      marginRight: 12
    }
  }
});

class MobileMenu extends Component {
  openMenu(evt) {
    evt.stopPropagation();
    this.setState({
      open: true
    });
  }

  closeMenu(evt) {
    evt.stopPropagation();
    this.setState({
      closing: true
    });
    this.hideMenu();
  }

  hideMenu() {
    setTimeout(() => {
      this.setState({
        open: false,
        closing: false
      });
    }, 200);
  }

  toggleMenu = menu => {
    this.setState({
      [menu]: !this.state[menu]
    });
  };

  constructor() {
    super();
    this.state = {
      open: false,
      closing: false,
      about: false,
      help: false
    };
    this.openMenu = this.openMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.hideMenu = this.hideMenu.bind(this);
  }
  render() {
    let { open } = this.state;
    const { locale, localeData } = this.props;
    const { consoleURL } = localeData;

    return (
      <div style={{ overflow: "hidden" }}>
        <div
          className={menuWrapper}
          style={{ transform: `translateX(${open ? "0vw" : "100vw"})` }}
        >
          <div className={header}>
            <img src={HumanitixLogo} alt="Humanitix logo" />
            <button
              onClick={this.closeMenu}
              className={closeButton}
              aria-expanded
              aria-label="Close menu"
            >
              <img src={closeIcon} alt="Close Icon" />
            </button>
          </div>
          <ul className={linksList}>
            <li>
              <Link
                activeClassName="link"
                href={`/${locale}/`}
                aria-label="Home - Humanitix"
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                activeClassName="link"
                href={`/${locale}/search`}
                aria-label="Search events"
              >
                Search Events
              </Link>
            </li>
            <li>
              <Link
                activeClassName="link"
                href={`/${locale}/features-and-pricing`}
                aria-label="Features and pricing"
              >
                Features &amp; Pricing
              </Link>
            </li>
            <li>
              <Link
                activeClassName="link"
                href={`/${locale}/our-impact`}
                aria-label="Our Impact"
              >
                Our Impact
              </Link>
            </li>
            <li>
              <DropDown
                title="About"
                open={this.state.about}
                toggle={() => this.toggleMenu("about")}
              >
                <li>
                  <Link
                    activeClassName="link"
                    href={`/${locale}/our-model`}
                    aria-label="Our Model"
                  >
                    Our Model
                  </Link>
                </li>
                <li>
                  <Link
                    activeClassName="link"
                    href={`/${locale}/our-story`}
                    aria-label="Our Story"
                  >
                    Our Story
                  </Link>
                </li>
              </DropDown>
            </li>
            <li>
              <DropDown
                title="Help"
                open={this.state.help}
                toggle={() => this.toggleMenu("help")}
              >
                <li>
                  <a
                    href={`https://humanitix.helpdocs.io/category/6tj7pgphsh-event-attendees`}
                    aria-label="Our Model"
                  >
                    Attending an event
                  </a>
                </li>
                <li>
                  <a
                    href={`https://humanitix.helpdocs.io/category/1f9mjr3lv6-event-organiser`}
                    aria-label="Our Story"
                  >
                    Hosting an event
                  </a>
                </li>
              </DropDown>
            </li>
          </ul>
          <div className={footer}>
            <SignUpButton ariaLabel="Sign In" size="medium" style="hollow">
              Sign In
            </SignUpButton>
            <SignUpButton ariaLabel="create event" size="medium">
              Create Event
            </SignUpButton>
          </div>
        </div>
        <div style={{ position: "relative", zIndex: 10 }}>
          <button
            onClick={this.openMenu}
            className={openButton}
            aria-expanded={open}
            aria-label="Open menu"
          >
            <img src={menuIcon} alt="Menu Icon" />
          </button>
        </div>
      </div>
    );
  }
}

export default CMSComponent(null, MobileMenu);
